import { useLocalStorage } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import { changelogAssetsMap } from '../../changelog/assetsMap'
import rawChangelog from '../../changelog/Changelog.md?raw'
import { useMarkdownMediaProcessor } from '../markdownviewer/useMarkdownMediaProcessor'

export const useChangelogDiff = () => {
  const [currentValue, setCurrentValue] = useLocalStorage<string>('changelog')
  const processedChangelog = useMarkdownMediaProcessor(
    rawChangelog,
    changelogAssetsMap,
  )

  const oldPartIndex = currentValue
    ? processedChangelog.lastIndexOf(currentValue)
    : processedChangelog.length

  const [newPart, oldPart] =
    oldPartIndex !== -1
      ? [
          processedChangelog.substring(0, oldPartIndex),
          processedChangelog.substring(oldPartIndex),
        ]
      : [processedChangelog, '']

  return useMemo(
    () => ({
      onRead: () => setCurrentValue(processedChangelog),
      newParts: newPart.split('---\n\n').filter(Boolean),
      oldParts: oldPart.split('---\n\n').filter(Boolean),
    }),
    [newPart, oldPart, processedChangelog, setCurrentValue],
  )
}
